import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Dashboard from './components/Dashboard/Dashboard';
import Widget from './components/Widget/Widget';
import Redeem from './components/Redeem/Redeem';
import RedeemDonate from './components/RedeemDonate/RedeemDonate';
import RedeemCash from './components/RedeemCash/RedeemCash';
import RedeemCashResults from './components/RedeemCash/RedeemCashResults';
import RewardsFeed from './components/rewardsfeed/rewardsfeed';
import GetPoints from './components/GetPoints/GetPoints';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/widget" element={<Widget />} />
        <Route path="/redeem" element={<Redeem />} />
        <Route path="/redeemdonate" element={<RedeemDonate />} />
        <Route path="/redeemcash" element={<RedeemCash />} />
        <Route path="/redeemcashresults" element={<RedeemCashResults />} />
        <Route path="/rewardsfeed" element={<RewardsFeed />} />
        <Route path="/getpoints" element={<GetPoints />} />
      </Routes>
    </div>
  );
}

export default App;